export function shouldLoadOneTrust(hostname = '', inclusionList = []) {
    for (const domain of inclusionList) {
        if (hostname.includes(domain)) {
            return true;
        }
    }
    return false;
}

export function loadOneTrust(params) {
    if (!__SERVER__) {
        const props = Object.assign(true, {}, params);
        const scriptEl = document.createElement('script');

        scriptEl.src = props.src;
        scriptEl.async = props.async;
        scriptEl.defer = props.defer;
        scriptEl.setAttribute('data-domain-script', props.key);

        scriptEl.onload = props.onSuccess;
        scriptEl.onerror = props.onError;

        document.body.appendChild(scriptEl);
    } else {
        throw new Error('notSupportedException');
    }
}

export function isExternalFooter(contextList = []) {
    const footerContext = contextList?.find(
        (item) => item?.context?.requestUrl?.indexOf('/footer') > 0
    );
    return typeof footerContext === 'object';
}
